import { useCallback, useEffect, useReducer, useState } from 'react';
import { useRouter, useSearchParams } from 'next/navigation';
import reducer, { actions } from './reducer';
import useForm from '../useForm';

const useMultiStepForm = ({ storeData, mutation, nextRoute, showSignLanguage = false }) => {
	const router = useRouter();
	const searchParams = useSearchParams();
	const [storeSnap, setStoreSnap] = useState(storeData);

	const [{ isReady, initial, validation, actualStep, title, prevRoute }, dispatch] = useReducer(reducer, {});

	const [formController, getFieldProps, { loading, submitting, success, errors, data }] = useForm({
		initialValues: initial,
		validationSchema: validation,
		mutation: mutation,
		onSuccess: data => {
			setStoreSnap(data);
			dispatch({ action: actions.NEXT_STEP, payload: { data } });
		},
	});

	const goPrev = useCallback(() => {
		dispatch({ action: actions.PREV_STEP, payload: { data: storeSnap } });
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [storeSnap]);

    const setMultistepData = useCallback(({multistepData, prevRoute, storeData = null}) => {
        dispatch({ action: actions.SET_MULTISTEP_DATA, payload: { multistepData, prevRoute, data: (storeData || storeSnap) } });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [storeSnap])

    useEffect(() => {
        if(prevRoute && nextRoute) {
            if (actualStep === 'start') {
                router.push(prevRoute);
            } else if (actualStep === 'finish') {
                router.push(nextRoute);
            }
        }

		// if(actualStep && typeof actualStep?.order === 'number') {
		// 	if(showSignLanguage) {
		// 		if(searchParams.get('sI') != actualStep.order) {
		// 			router.replace(`${router.pathname}?sI=${actualStep.order}`)	
		// 		}
		// 	} else if(searchParams.get('sI') != 99999) {
		// 		router.replace(`${router.pathname}?sI=${actualStep.order}`)	
		// 	}
		// }
    }, [actualStep, router, prevRoute, nextRoute, showSignLanguage, searchParams]);

	return {
        isReady,

		formController,
		getFieldProps,
		loading,
		submitting,
		success,
		errors,
		data,

		actualStep,
		title,

		goPrev,
        setMultistepData,
	};
};

export default useMultiStepForm;
